import { api } from '../api/client.js';

// Týdenní report (JCH-Report). Talks to /api/v1/reports, a JCH-only route.
//
// Backend: GET /reports → { reports, count }. Each row is the raw reports
// table joined to the makler's name (makler_name, makler_email, report_type,
// generated_at) plus delivery fields (email_status, email_sent_to,
// push_notification_sent). No closed-week semafor / plan / red-weeks columns
// are surfaced by this route — those live in the open weekly plan.
//
// PATCH /:id/status → { status } (draft/finalized/archived), and PATCH
// /:id/email → { emailSentTo, emailStatus } record e-mail delivery.

export function listReports(query = {}) {
  return api.get('/reports', { params: query }).then((r) => r.data.data);
}

export function updateReportStatus(id, status) {
  return api.patch(`/reports/${id}/status`, { status }).then((r) => r.data.data);
}

export function setEmail(id, { emailSentTo, emailStatus }) {
  return api
    .patch(`/reports/${id}/email`, { emailSentTo, emailStatus })
    .then((r) => r.data.data);
}
